import { produce } from "immer";
import {
  //
  ADD_HOME_GROUP_STAFF,
  ADD_HOME_GROUP_STAFF_FAILURE,
  ADD_HOME_GROUP_STAFF_SUCCESS,
  //
  DELETE_HOME_GROUP_STAFF,
  DELETE_HOME_GROUP_STAFF_SUCCESS,
  DELETE_HOME_GROUP_STAFF_FAILURE,
  //
  EDIT_HOME_GROUP_STAFF,
  EDIT_HOME_GROUP_STAFF_FAILURE,
  EDIT_HOME_GROUP_STAFF_SUCCESS,
  //
  FETCH_HOME_GROUP_STAFFS,
  FETCH_HOME_GROUP_STAFFS_FAILURE,
  FETCH_HOME_GROUP_STAFFS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_STAFF_ADD_MODAL,
  CLOSE_STAFF_ADD_MODAL,
  //
  OPEN_STAFF_EDIT_MODAL,
  CLOSE_STAFF_EDIT_MODAL,
} from "./constants";

export const initialState = {
  isFetchingHomesStaff: false,
  HomesStaff: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentHomeStaff: {},
  // Delete
  isDeleting: false,
  //
  isStaffAddModalOpen: false,
  isSearching: false,
  searchHomeList: [],

  isStaffEditModalOpen: false,
};

const HomeGroupStaffReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_HOME_GROUP_STAFFS:
        draft.isFetchingHomesStaff = true;
        draft.currentHomeAdmin = {};
        break;
      case FETCH_HOME_GROUP_STAFFS_SUCCESS:
        draft.isFetchingHomesStaff = false;
        draft.HomesStaff = action.payload;
        break;
      case FETCH_HOME_GROUP_STAFFS_FAILURE:
        draft.isFetchingHomesStaff = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentHomeStaff = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentHomeStaff = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_HOME_GROUP_STAFF:
        draft.isSubmitting = true;
        break;
      case ADD_HOME_GROUP_STAFF_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_HOME_GROUP_STAFF_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_HOME_GROUP_STAFF:
        draft.isSubmitting = true;
        break;
      case EDIT_HOME_GROUP_STAFF_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_HOME_GROUP_STAFF_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_HOME_GROUP_STAFF:
        draft.isDeleting = true;
        break;
      case DELETE_HOME_GROUP_STAFF_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_HOME_GROUP_STAFF_FAILURE:
        draft.isDeleting = false;
        break;
      case OPEN_STAFF_ADD_MODAL:
        draft.isStaffAddModalOpen = true;
        draft.currentHomeStaff = {};
        break;
      case CLOSE_STAFF_ADD_MODAL:
        draft.isStaffAddModalOpen = false;
        draft.currentHomeStaff = {};
        break;
      case OPEN_STAFF_EDIT_MODAL:
        draft.isStaffEditModalOpen = true;
        draft.currentHomeStaff = {};
        break;
      case CLOSE_STAFF_EDIT_MODAL:
        draft.isStaffEditModalOpen = false;
        draft.currentHomeStaff = {};
        break;
      default:
        return state;
    }
  });

export default HomeGroupStaffReducer;
